// extracted by mini-css-extract-plugin
module.exports = {"authButton":"Button_authButton__kh0Wb","socialMediaButton":"Button_socialMediaButton__sUN2o"};